import React, { useState } from "react";
import { Box, Button, FormControl, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "react-phone-input-2/lib/bootstrap.css";
import { usePostForgotPasswordMutation } from "../../services/auth";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Loader, showError, showToast } from "../../constants";
import useTranslation from "../../hooks/Translation";

const Login = () => {
  const translation = useTranslation() as any;
  const navigate = useNavigate();

  const [ForgotPasswordMutation, { isLoading }] =
    usePostForgotPasswordMutation();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required(translation.error.emailReq)
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          translation.error.validEmail
        ),
    }),
    onSubmit: async () => {
      formik.setSubmitting(true);
      let body = {
        key: formik.values.email,
      };

      try {
        const response = await ForgotPasswordMutation(body).unwrap();
        if (response?.statusCode === 200) {
          const data = {
            // page: 'login'
            key: formik.values.email,
            page: "forgot",
          };
          navigate("/verify-otp", { state: data });
          showToast(response?.message);
        }
      } catch (error: any) {
        showError(error?.data?.message || "");
      }
    },
  });

  return (
    <div className="authh">
      <Loader isLoad={isLoading} />
      <div className="conta_iner">
        <div className="auth_parnt">
          <div className="auth_left">
            <figure className="authLogo">
              <img src="/static/images/logo.png" alt="" />
            </figure>
            <h2>{translation?.auth.forgotPassword} </h2>
            <Box sx={{ paddingBottom: 5 }}></Box>
            <form onSubmit={formik.handleSubmit}>
              <FormControl sx={{ width: "100%" }}>
                <Typography className="custom_label">
                  {translation.auth.emailId}
                </Typography>
                <TextField
                  className="text_field"
                  hiddenLabel
                  placeholder={translation.auth.emailId}
                  fullWidth
                  name="email"
                  type="email"
                  variant="outlined"
                  id="email"
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </FormControl>
              <Box sx={{ pt: 3 }}>
                <Button
                  className="btn btn_primary"
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  {translation.globals.send}
                </Button>
              </Box>
            </form>
          </div>
          <div className="auth_ryt">
            <div className="absolute_div">
              <h3>{translation.auth.welcome}</h3>
              <p>{translation.auth.already}</p>
              <Box sx={{ pt: 3, display: "flex", justifyContent: "center" }}>
                <Button
                  className="btn"
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  onClick={() => navigate("/")}
                >
                  {translation.auth.login}
                </Button>
              </Box>
            </div>
            <figure>
              <img src="/static/images/cook2.jpg" alt="" />
            </figure>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
